import { RouteRecordRaw } from 'vue-router';
import { Layout } from '@/router/constant';
import {
  CalculatorOutlined,
  CalendarOutlined,
  SnippetsOutlined,
  ScheduleOutlined,
} from '@vicons/antd';
import { PricetagOutline, BusinessOutline } from '@vicons/ionicons5';
import { renderIcon } from '@/utils/index';

/**
 * @param name 路由名称, 必须设置,且不能重名
 * @param meta 路由元信息（路由附带扩展信息）
 * @param redirect 重定向地址, 访问这个路由时,自定进行重定向
 * @param meta.disabled 禁用整个菜单
 * @param meta.title 菜单名称
 * @param meta.prefix 菜单名称前缀, 用于确定唯一名称
 * @param meta.icon 菜单图标
 * @param meta.keepAlive 缓存该路由
 * @param meta.permissions 配置系统权限, 缺省开放所有权限
 * @param meta.sort 排序越小越排前
 * @param meta.hidden 从菜单中隐藏
 * @param meta.alwaysShow 总是显示菜单
 * @param meta.isRoot 单级菜单
 * */
const routes: Array<RouteRecordRaw> = [
  {
    path: '/estimate',
    name: 'estimate',
    redirect: '/estimate/template',
    component: Layout,
    meta: {
      title: 'Estimate',
      icon: renderIcon(CalculatorOutlined),
      //这里配置父级路由需要哪些权限可访问 这里是子路由权限集合
      permissions: [
        'estimate_template_read',
        'estimate_room_read',
        'estimate_plan_read',
        'estimate_equipment_read',
      ],
      sort: 6,
    },
    children: [
      {
        path: 'task',
        name: 'estimate_task',
        meta: {
          title: 'Task',
          prefix: 'Estimate',
          icon: renderIcon(ScheduleOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['estimate_task_read'],
        },
        component: () => import('@/views/estimate/task/index.vue'),
      },
      /*
      {
        path: 'plan',
        name: 'estimate_plan',
        meta: {
          title: 'Plan',
          prefix: 'Estimate',
          icon: renderIcon(CalendarOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['estimate_plan_read'],
        },
        component: () => import('@/views/estimate/plan/index.vue'),
      },
      */
      {
        path: 'room',
        name: 'estimate_room',
        meta: {
          title: 'Room',
          prefix: 'Estimate',
          icon: renderIcon(BusinessOutline),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['estimate_room_read'],
        },
        component: () => import('@/views/estimate/room/index.vue'),
      },
      {
        path: 'template',
        name: 'estimate_template',
        meta: {
          title: 'Template',
          prefix: 'Estimate',
          icon: renderIcon(SnippetsOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['estimate_template_read'],
        },
        component: () => import('@/views/estimate/template/index.vue'),
      },
      /*
      {
        path: 'equipment',
        name: 'estimate_equipment',
        meta: {
          title: 'Equipment',
          prefix: 'Estimate',
          icon: renderIcon(PricetagOutline),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['estimate_equipment_read'],
        },
        component: () => import('@/views/estimate/equipment/index.vue'),
      },
      */
      {
        path: 'Estimate',
        name: 'estimate_plan',
        meta: {
          title: 'Estimate',
          prefix: '',
          spname: "estimate",
          icon: renderIcon(CalendarOutlined),
          //配置该路由需要哪些权限可访问 这里是针对单个路由
          permissions: ['estimate_plan_read'],
        },
        component: () => import('@/views/estimate/estimate/index.vue'),
      },
    ],
  },
];

export default routes;
